// extracted by mini-css-extract-plugin
export default {"headerContainer":"shipmentReport_headerContainer__Su3Md"};